module.exports = __webpack_public_path__ + "img/blog-5.00e71d35.jpg";